import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {UmpireCompetitionSeason} from '@tisa-group/models';
import {UmpireCompetitionsSquad} from '@tisa-group/models/umpire/umpire-competitions-squad';

@Injectable()
export class CompetitionSeasonService implements CrudService<UmpireCompetitionSeason> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireCompetitionSeason[]>> {
    return this.http
      .get(`/competition_seasons`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireCompetitionSeason>> {
    return this.http
      .get(`/competition_seasons/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    competitionSeason: Partial<UmpireCompetitionSeason>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireCompetitionSeason>> {
    return this.http
      .patch(
        `/competition_seasons/${competitionSeason.id}`,
        serialize({stuff: competitionSeason}),
        {params: objectToHttpParams(params)},
      )
      .pipe(deserialize());
  }

  create(
    competitionSeason: Partial<UmpireCompetitionSeason>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireCompetitionSeason>> {
    return this.http
      .post('/competition_seasons', serialize({stuff: competitionSeason}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(competitionSeasonId: string): Observable<void> {
    return this.http.delete(`/competition_seasons/${competitionSeasonId}`);
  }

  fetchCompetitionSquads(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireCompetitionsSquad[]>> {
    return this.http
      .get(`/competition_seasons/${fetchIdentifier}/competitions_squads`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  createCompetitionSquads(
    competitionSeasonId: string,
    body: Partial<UmpireCompetitionsSquad>,
  ) {
    return this.http
      .post(
        `/competition_seasons/${competitionSeasonId}/competitions_squads`,
        serialize({stuff: body}),
      )
      .pipe(deserialize());
  }
}
